import {RouterModule, Routes} from '@angular/router';
import {LoginPageComponent} from "./pages/login-page/login-page.component";
import {NgModule} from "@angular/core";
import {TransactionPageComponent} from "./pages/transaction-page/transaction-page.component";
import {AuthGuard} from "./utils/auth.guard";
import {StocksPageComponent} from "./pages/stocks-page/stocks-page.component";
import {ItemsPageComponent} from "./pages/items-page/items-page.component";
import {HomePageComponent} from "./pages/home-page/home-page.component";
import {AdminPageComponent} from "./pages/admin-page/admin-page.component";
import {InvoicePageComponent} from "./pages/invoice-page/invoice-page.component";

export const routes: Routes = [
  {
    path: 'transactions',
    component: TransactionPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'stocks',
    component: StocksPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'stocks/:stock-level',
    component: StocksPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: '',
    component: HomePageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'items',
    component: ItemsPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    component: LoginPageComponent
  },
  {
    path: 'admin',
    component: AdminPageComponent,
    canActivate: [AuthGuard],
  },
    {
    path: 'invoice',
    component: InvoicePageComponent,
    canActivate: [AuthGuard],
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
